import { FC, useState } from 'react';

import { useTitle } from '../hooks/useTitle';

import FindPassword from '../components/FindPassword/FindPassword';
import Signin from '../components/Signin/Signin';

const SigninPage: FC = () => {
  useTitle('GU | 로그인');
  const [findPassword, setFindPassword] = useState(false);

  return findPassword ? (
    <FindPassword backToSignin={() => setFindPassword(false)} />
  ) : (
    <Signin goToFindPassword={() => setFindPassword(true)} />
  );
};

export default SigninPage;
